import { createSelector } from '@ngrx/store';
import { getRmsSpecificationPage } from './index';

export const getProductsState = createSelector(getRmsSpecificationPage, state => state.productsLegacyState);
export const getOpenPlatformProductsState = createSelector(
  getRmsSpecificationPage,
  state => state.productsOpenPlatformState,
);

export const getIsContractProductLoading = createSelector(getProductsState, state => state.loading);
export const getOpenPlatformIsProductLoading = createSelector(getOpenPlatformProductsState, state => state.loading);

export const getAvailableProducts = createSelector(getProductsState, state => state.availableProducts);
export const getOpenPlatformProducts = createSelector(getOpenPlatformProductsState, state => state.availableProducts);
